import {
  ArrowUpTrayIcon,
  PlusIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";
import useAxios from "axios-hooks";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import MemberForm from "./form/MemberForm";
import { UserResDto, UsersResDto } from "../../api/Api";
import AutocompleteInput from "../../components/input/AutoCompleteInput";
import moment from "moment";
import PaginationButtons from "../../components/pagination/PaginationButtons";
export function MembersTable({ data }: { data: UserResDto[] | undefined }) {
  const navigate = useNavigate();

  return (
    <div className="overflow-x-auto rounded-xl table-container border border-base-300 bg-base-100">
      <table className="table table-md w-full">
        <thead className="bg-base-200 sticky top-0 z-10 text-sm">
          <tr>
            <th>#</th>
            <th>Username</th>
            <th>Email</th>
            <th>Classrooms</th>
            <th>Status</th>
            <th className="text-center">Joined</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((member, index) => (
            <tr
              key={member._id}
              className="hover:bg-base-300 transition cursor-pointer"
              onClick={() => navigate(`/students/${member._id}/stats`)}
            >
              <td>{index + 1}</td>

              <td className="font-medium whitespace-nowrap">
                {member.username}
              </td>

              <td className="text-base-content/70 text-sm whitespace-nowrap">
                {member.email}
              </td>

              <td className="space-y-1">
                {member.classrooms?.length > 0 ? (
                  <div className="flex flex-wrap gap-1">
                    {member.classrooms.map((classroom: any) => (
                      <span
                        key={classroom._id}
                        className="badge badge-outline badge-sm"
                      >
                        {classroom.name}
                      </span>
                    ))}
                  </div>
                ) : (
                  <span className="text-xs text-base-content/50 italic">
                    No classrooms
                  </span>
                )}
              </td>

              <td>
                {member.enabled ? (
                  <span className="badge badge-success badge-sm">Active</span>
                ) : (
                  <span className="badge badge-error badge-sm">Disabled</span>
                )}
              </td>

              <td className="text-center text-xs text-base-content/60">
                {moment(member.createdAt).fromNow()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function Members(props: {
  classroomIds?: string[];
  showImport?: boolean;
}) {
  const outletContext = useOutletContext() as any;
  const navigate = useNavigate();

  const [searchString, setSearchString] = useState(undefined as any);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [{ data, loading, error }, getMembers] = useAxios<UsersResDto>({
    url: "/users",
    params: {
      search: searchString,
      ...(props.classroomIds ? { classroomIds: props.classroomIds } : {}),
      roles: ["BUSINESS_MEMBER"],
      page,
      limit: pageSize,
    },
  });

  useEffect(() => {
    outletContext?.setTitleComponent(
      <div className="flex items-center justify-center gap-2">
        <UserGroupIcon className="h-8 w-8"></UserGroupIcon>
        Students
      </div>
    );
  }, []);

  useEffect(() => {
    if (searchString !== undefined) {
      setPage(1);
    }
  }, [searchString]);

  // useEffect(() => {
  //   getMembers();
  // }, [searchString, page, pageSize]);

  return (
    <div className="flex flex-col gap-2 p-5">
      <div className="flex">
        <div className="mb-2">
          <AutocompleteInput
            onComplete={(input: string) => {
              setSearchString(input);
            }}
            placeHolder="Search..."
            className="bg-base-200"
          />
        </div>
        <div className="ml-auto">
          <button
            className="btn btn-sm"
            onClick={() => {
              (
                document?.getElementById("new_member_modal") as any
              )?.showModal();
            }}
          >
            <PlusIcon className="h-4" />
            New Student
          </button>
        </div>
      </div>

      {!loading ? (
        <div className="flex gap-4 flex-col">
          <MembersTable data={data?.docs} />
          <PaginationButtons
            page={page}
            setPage={setPage}
            pageCount={data?.totalPages || 1}
            pageSize={pageSize}
            setPageSize={setPageSize}
          />
        </div>
      ) : (
        <div className="h-[20vh] w-full flex items-center justify-center">
          <span className="loading loading-spinner loading-md"></span>
        </div>
      )}

      <dialog id="new_member_modal" className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg pb-2">Create Student</h3>
           <form method="dialog">
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
              ✕
            </button>
          </form>
          <div>
            <MemberForm
              onSuccess={(user: UserResDto) => {
                navigate(`/students/${user?._id}/stats`);
              }}
            />
          </div>
        </div>
      </dialog>
    </div>
  );
}
